import { render, staticRenderFns } from "./PrintOrderDetails.vue?vue&type=template&id=f998ea04&"
import script from "./PrintOrderDetails.vue?vue&type=script&lang=js&"
export * from "./PrintOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports